import React from 'react';

import clsx from 'clsx';

import {
    Button,
    Glyphicon,
    Image,
    ItemCard,
    Panel,
    SubHeading,
} from 'reaxl';
import { DelayedImpressionObserver, sendClick, sendImpressions } from 'reaxl-analytics';

import { treehouseAdCTAClick, treehouseImpression } from '@/analytics/treehouseAdEvents';

function TreehouseAdPlacement({ uiContext = 'portrait', isXs = false, listing = {} }) {

    const TREEHOUSE_AD_CONSTANTS = {
        FULL_DESCRIPTION: 'Ford has partnered with Treehouse to make home charging installation easy.',
        SHORT_DESCRIPTION: 'Treehouse makes home charging installation easy.',
        IMG_SRC: '/cm-api/content/static/img/fba/treehouse_ad.png',
        AD_URL: `https://pages.treehouse.pro/ford-blueadvantage${listing?.vin ? `?vin=${listing?.vin}` : ''}`,
    };

    const renderHeaderAndDescription = (
        <div className="padding-4">
            <SubHeading
                size={isXs ? 600 : 500} // keep size consistent for mobile heading
            >
                Fully Charge Your EV Overnight
            </SubHeading>
            {(uiContext === 'portrait' && !isXs) ? TREEHOUSE_AD_CONSTANTS.FULL_DESCRIPTION : TREEHOUSE_AD_CONSTANTS.SHORT_DESCRIPTION}
        </div>
    );

    const renderButton = (
        <div className="padding-4 display-flex justify-content-center">
            <Button
                bsStyle="secondary"
                block={uiContext !== 'horizontal'}
                href={TREEHOUSE_AD_CONSTANTS.AD_URL}
                onClick={(e) => {
                    sendClick(treehouseAdCTAClick, e, { inventory: listing });
                }}
                role="button"
                target="_blank"
            >
                Get a Free Estimate
                <Glyphicon
                    glyph="offsite"
                    className="margin-left-1"
                />
            </Button>
        </div>
    );

    return (
        <DelayedImpressionObserver
            key="treehouse-ad-placement"
            onChange={() => {
                sendImpressions({ name: treehouseImpression, data: { inventory: listing } });
            }}
            delay={0}
            id="treehouse-ad-placement"
            className="display-flex"
        >
            <Panel
                data-cmp="treehouse-ad"
                className={clsx('display-flex w-100 padding-0', {
                    'flex-column': uiContext !== 'horizontal',
                })}
            >
                <Image
                    src={TREEHOUSE_AD_CONSTANTS.IMG_SRC}
                    alt="Treehouse Ad"
                    loading="eager"
                    width={uiContext === 'horizontal' ? '30%' : '100%'}
                />
                <ItemCard
                    body={renderHeaderAndDescription}
                    footer={renderButton}
                />
            </Panel>
        </DelayedImpressionObserver>
    );
}

export default TreehouseAdPlacement;
